import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import SearchAndSortableTable from '../../../../../../../components/table/SearchAndSortableTable';
import { useGetSelectedStudentTable, useHandleActiveStudentFilter } from './StudentTableSelectorHooks';
import './StudentTableSelector.scss';
import { filterUndefined } from '../../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  onDataChange: () => null,
  teacherStudentSelectorTableData: {},
  selectedStudentIds: [],
};

const StudentTableSelector = (p) => {
  const {
    onDataChange,
    selectedStudentIds,
    teacherStudentSelectorTableData,
  } = { ...defaultProps, ...filterUndefined(p) };

  const {
    studentFilterValue,
    handleStudentFilterChange,
  } = useHandleActiveStudentFilter();
  const {
    tableConfig,
    tableData,
  } = useGetSelectedStudentTable({
    selectedStudentIds,
    onDataChange,
    teacherStudentSelectorTableData,
    activeStudent: studentFilterValue,
  });

  return (
    <div className='student-table-selector'>
      <SearchAndSortableTable
        containerClassName='student-selector-table'
        config={tableConfig}
        tableData={tableData}
        searchPlaceholder='Search your students'
        initTableState={{
          order: 'desc',
          orderBy: 'isSelected',
        }}
        toolbarActions={[
          <ToggleButtonGroup
            size='small'
            value={studentFilterValue}
            exclusive
            className='switch-toggle student-active-switch-toggle'
            onChange={handleStudentFilterChange}
          >
            <ToggleButton value>
              Active
            </ToggleButton>
            <ToggleButton value={false}>
              Inactive
            </ToggleButton>
          </ToggleButtonGroup>,
        ]}
        searchFunction={(keyword, data) => {
          const name = `${data.firstName} ${data.lastName}`;
          const isNameMatched = name.toLowerCase().indexOf(keyword.toLowerCase()) >= 0;
          const isEmailMatched = data.username.toLowerCase().indexOf(keyword.toLowerCase()) >= 0;
          return isNameMatched || isEmailMatched;
        }}
        autoResetTableState={false}
      />
    </div>
  );
};

export default StudentTableSelector;
